import React from "react"
import RecipeResults from "../RecipeListing/RecipeResults"

import { useLocale } from "../../../context/LocaleContext"
import { RecipeCollectionListingModule } from "../../../models/modules"

interface Props extends RecipeCollectionListingModule {
  pageContext: any
}
const defaultProps = {}

export const RecipeCollectionListing: React.FC<Props> = props => {
  // console.log("RecipeCollectionListing: ", props)
  if (
    !(
      props.collection &&
      props.collection.length &&
      props.collection[0].recipes &&
      props.collection[0].recipes.length
    )
  )
    return null
  // context
  const { locale } = useLocale().localeData

  return (
    <section className="listing recipeListing">
      <div className="grid-x grid-margin-x align-center">
        <div className="cell">
          {props.title && (
            <h2
              className={props.center_title_text ? "text-center" : ""}
              style={{ marginBottom: 30 }}
            >
              {props.title || props.collection?.[0].hero.heading}
            </h2>
          )}
        </div>
      </div>
      <RecipeResults
        items={
          props.number_of_records
            ? props.collection[0].recipes.slice(0, props.number_of_records)
            : props.collection[0].recipes
        }
        showAll={true}
        pageContext={props.pageContext}
      />
    </section>
  )
}

RecipeCollectionListing.defaultProps = defaultProps

export default RecipeCollectionListing
